export const TABS = { PRACTICE: 'practice', ALL: 'all', INVITE: 'invite' };
